import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import * as util from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';

class SalaryRaise extends Component {

    state = {
        selectedEmployee: { value: this.props.row.employee.privateId, label: this.props.row.employee.name },
        currentGrossSalary: this.props.row.employee.currentGrossSalary,
        currentNetSalary: this.props.row.employee.currentNetSalary,
        date: new Date(),
        comment: '',
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            selectedEmployee: { value: this.props.row.employee.privateId, label: this.props.row.employee.name },
            currentGrossSalary: this.props.row.employee.currentGrossSalary,
            currentNetSalary: this.props.row.employee.currentNetSalary,
            date: new Date(),
            comment: '',
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/salaryraise';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value,
            "currentGrossSalary": util.toNumber(this.state.currentGrossSalary),
            "currentNetSalary": util.toNumber(this.state.currentNetSalary),
            "date": this.state.date,
            "comment": this.state.comment,
        };

        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            id="currentGrossSalary"
                            name="currentGrossSalary"
                            label="Új bruttó fizetés"
                            errors={this.state.errors}
                            prevValue={this.props.row.employee.currentGrossSalary}
                            value={this.state.currentGrossSalary}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            id="currentNetSalary"
                            name="currentNetSalary"
                            label="Új nettó fizetés"
                            errors={this.state.errors}
                            prevValue={this.props.row.employee.currentNetSalary}
                            value={this.state.currentNetSalary}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="date"
                            label="Mikortól"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={e => handleDateChangeEvent(e, "date", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(SalaryRaise);
